import { useCallback } from 'react'
import { LANDING_SECTIONS, scrollToSection } from '@/config/assets'

/**
 * Hook for smooth scrolling to landing page sections
 */
export function useSmoothScroll() {
  const scrollTo = useCallback((sectionId: keyof typeof LANDING_SECTIONS) => {
    scrollToSection(LANDING_SECTIONS[sectionId])
  }, [])

  const scrollToHowItWorks = useCallback(() => scrollTo('howItWorks'), [scrollTo])
  const scrollToPricing = useCallback(() => scrollTo('pricing'), [scrollTo])
  const scrollToFaq = useCallback(() => scrollTo('faq'), [scrollTo])
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return {
    scrollTo,
    scrollToHowItWorks,
    scrollToPricing,
    scrollToFaq,
    scrollToTop,
  }
}
